(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.FarmFieldController = (function(superClass) {
    extend(FarmFieldController, superClass);

    function FarmFieldController(scope, transitions, repo, modal) {
      var first_field;
      this.scope = scope;
      this.transitions = transitions;
      this.repo = repo;
      this.modal = modal;
      this.hasRemainingDuplicates = bind(this.hasRemainingDuplicates, this);
      this.isSurveyResultSelected = bind(this.isSurveyResultSelected, this);
      this.toggleSurveyResult = bind(this.toggleSurveyResult, this);
      this.viewPlan = bind(this.viewPlan, this);
      this.viewDetails = bind(this.viewDetails, this);
      this.showSurveyFields = bind(this.showSurveyFields, this);
      this.canContinue = bind(this.canContinue, this);
      this.includeDuplicates = bind(this.includeDuplicates, this);
      this.next = bind(this.next, this);
      this.loadNextFieldYear = bind(this.loadNextFieldYear, this);
      this.isLastFieldYear = bind(this.isLastFieldYear, this);
      this.previous = bind(this.previous, this);
      this.loadPreviousFieldYear = bind(this.loadPreviousFieldYear, this);
      this.isFirstFieldYear = bind(this.isFirstFieldYear, this);
      this.sanityCheck = bind(this.sanityCheck, this);
      this.loadSurveyResults = bind(this.loadSurveyResults, this);
      this.setFieldYear = bind(this.setFieldYear, this);
      FarmFieldController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.step.title = 'Farm - Field';
      this.scope.step.next = this.next;
      this.scope.step.previous = this.previous;
      this.scope.step.includeDuplicates = this.includeDuplicates;
      this.scope.step.canContinue = this.canContinue;
      this.scope.placeholder = 'No surveys to display';
      this.scope.survey_results = [];
      this.scope.showSurveyFields = this.showSurveyFields;
      this.scope.viewDetails = this.viewDetails;
      this.scope.viewPlan = this.viewPlan;
      this.scope.toggleSurveyResult = this.toggleSurveyResult;
      this.scope.isSurveyResultSelected = this.isSurveyResultSelected;
      this.scope.numPlans = (function(_this) {
        return function(sr) {
          return Object.keys(sr.planned_fields).length;
        };
      })(this);
      first_field = this.scope.selected.duplicate_fields[0];
      this.setFieldYear(first_field, first_field.years[0]);
    }

    FarmFieldController.prototype.setFieldYear = function(field, year) {
      this.scope.current_field = field;
      this.scope.current_year = year;
      this.scope.step.title = field.farm_name + " - " + field.name;
      return this.loadSurveyResults();
    };

    FarmFieldController.prototype.loadSurveyResults = function() {
      var j, len, ref, survey_result;
      this.scope.survey_results = [];
      ref = this.scope.selected.survey_results;
      for (j = 0, len = ref.length; j < len; j++) {
        survey_result = ref[j];
        if (survey_result.year === this.scope.current_year && (survey_result.planned_fields[this.scope.current_field.id] != null)) {
          this.scope.survey_results.push(survey_result);
        }
      }
      return this.sanityCheck();
    };

    FarmFieldController.prototype.sanityCheck = function() {
      var j, ref, results, survey_result;
      ref = this.scope.current_field.survey_results[this.scope.current_year];
      results = [];
      for (j = ref.length - 1; j >= 0; j += -1) {
        survey_result = ref[j];
        if (_.findIndex(this.scope.survey_results, {
          id: survey_result.id
        }) === -1) {
          results.push(this.toggleSurveyResult(survey_result));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    FarmFieldController.prototype.isFirstFieldYear = function() {
      var first_field;
      first_field = this.scope.selected.duplicate_fields[0];
      return this.scope.current_field === first_field && this.scope.current_year === first_field.years[0];
    };

    FarmFieldController.prototype.loadPreviousFieldYear = function() {
      var field_index, first_field, prev_field, prev_year, year_index;
      year_index = this.scope.current_field.years.indexOf(this.scope.current_year);
      if (year_index > 0) {
        prev_year = this.scope.current_field.years[year_index - 1];
        return this.setFieldYear(this.scope.current_field, prev_year);
      } else {
        field_index = _.findIndex(this.scope.selected.duplicate_fields, {
          id: this.scope.current_field.id
        });
        if (field_index > 0) {
          prev_field = this.scope.selected.duplicate_fields[field_index - 1];
          return this.setFieldYear(prev_field, _.last(prev_field.years));
        } else {
          first_field = this.scope.selected.duplicate_fields[0];
          return this.setFieldYear(first_field, first_field.years[0]);
        }
      }
    };

    FarmFieldController.prototype.previous = function() {
      this.scope.$parent.clearAlert();
      if (this.isFirstFieldYear()) {
        return this.scope.goToStep('duplicate_fields');
      } else {
        return this.loadPreviousFieldYear();
      }
    };

    FarmFieldController.prototype.isLastFieldYear = function() {
      var last_field;
      last_field = _.last(this.scope.selected.duplicate_fields);
      return this.scope.current_field === last_field && this.scope.current_year === _.last(last_field.years);
    };

    FarmFieldController.prototype.loadNextFieldYear = function() {
      var field_index, first_field, next_field, next_year, year_index;
      year_index = this.scope.current_field.years.indexOf(this.scope.current_year);
      if (year_index < (this.scope.current_field.years.length - 1)) {
        next_year = this.scope.current_field.years[year_index + 1];
        return this.setFieldYear(this.scope.current_field, next_year);
      } else {
        field_index = _.findIndex(this.scope.selected.duplicate_fields, {
          id: this.scope.current_field.id
        });
        if (field_index < (this.scope.selected.duplicate_fields.length - 1)) {
          next_field = this.scope.selected.duplicate_fields[field_index + 1];
          return this.setFieldYear(next_field, next_field.years[0]);
        } else {
          first_field = this.scope.selected.duplicate_fields[0];
          return this.setFieldYear(first_field, first_field.years[0]);
        }
      }
    };

    FarmFieldController.prototype.next = function() {
      this.scope.$parent.clearAlert();
      if (this.isLastFieldYear()) {
        if (this.hasRemainingDuplicates()) {
          return this.scope.goToStep('download');
        } else {
          return this.repo.launchPsr(this.scope.selected, this.scope.step);
        }
      } else {
        return this.loadNextFieldYear();
      }
    };

    FarmFieldController.prototype.includeDuplicates = function() {
      var j, len, ref, survey_result;
      ref = this.scope.survey_results;
      for (j = 0, len = ref.length; j < len; j++) {
        survey_result = ref[j];
        if (!this.isSurveyResultSelected(survey_result)) {
          this.toggleSurveyResult(survey_result);
        }
      }
      return this.next();
    };

    FarmFieldController.prototype.canContinue = function() {
      var ref;
      return ((ref = this.scope.current_field) != null ? ref.survey_results[this.scope.current_year].length : void 0) > 0;
    };

    FarmFieldController.prototype.showSurveyFields = function(survey_result) {
      var modal_instance;
      return modal_instance = this.modal.open({
        windowClass: 'small_dialog',
        templateUrl: 'backend/grower/placement/survey-fields-dialog',
        controller: 'Placement.Controllers.SurveyFieldsDialogController',
        scope: this.scope,
        resolve: {
          'survey_result': function() {
            return survey_result;
          }
        }
      });
    };

    FarmFieldController.prototype.viewDetails = function(survey_result, field) {
      var modal_instance;
      return modal_instance = this.modal.open({
        windowClass: 'large_dialog',
        templateUrl: 'backend/grower/placement/report/survey-details-dialog',
        controller: 'Placement.Controllers.SurveyDetailsDialogController',
        scope: this.scope,
        resolve: {
          'survey_result': function() {
            return survey_result;
          },
          'field': function() {
            return field;
          }
        }
      });
    };

    FarmFieldController.prototype.viewPlan = function(survey_result, field) {
      var modal_instance;
      return modal_instance = this.modal.open({
        windowClass: 'dialog_500',
        templateUrl: 'backend/grower/placement/report/plan-details-dialog',
        controller: 'Placement.Controllers.PlanDetailsDialogController',
        scope: this.scope,
        resolve: {
          'survey_result': function() {
            return survey_result;
          },
          'field': function() {
            return field;
          }
        }
      });
    };

    FarmFieldController.prototype.toggleSurveyResult = function(survey_result) {
      var i;
      i = _.findIndex(this.scope.current_field.survey_results[this.scope.current_year], {
        id: survey_result.id
      });
      if (i === -1) {
        return this.scope.current_field.survey_results[this.scope.current_year].push(survey_result);
      } else {
        return this.scope.current_field.survey_results[this.scope.current_year].splice(i, 1);
      }
    };

    FarmFieldController.prototype.isSurveyResultSelected = function(survey_result) {
      return _.findIndex(this.scope.current_field.survey_results[this.scope.current_year], {
        id: survey_result.id
      }) > -1;
    };

    FarmFieldController.prototype.hasRemainingDuplicates = function() {
      var field, j, len, ref, ref1, survey_results, year;
      ref = this.scope.selected.duplicate_fields;
      for (j = 0, len = ref.length; j < len; j++) {
        field = ref[j];
        ref1 = field.survey_results;
        for (year in ref1) {
          survey_results = ref1[year];
          if (survey_results.length !== 1) {
            return true;
          }
        }
      }
      return false;
    };

    return FarmFieldController;

  })(Controller);

}).call(this);
